import React , { useState, useEffect }from 'react'

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ApiCallGet } from '../components/ApiCall/ApiCall';
import UploadDataSpinner from '../components/UploadDataSpinner';
import MoveScroller from '../components/MoveTable/MoveScroller'; //from '../components/MoveTable/MoveScroller';



function Grouped() {

    const [data, setData] = useState([]);
    const [showUpload, setShowUpload] = useState(false);
    const [dataShow,setDataShow] = useState([]) 
    const [count,setCount] = useState(0)   
    const [theVal,settheVal] = useState({first:0,len:10})
    const [order, setOrder] = useState("Asc") // Orden de la tabla (Asc o Desc)


    function onNewPos( val ) {
        console.log( "onNewPos = ", val )
        //console.log( "dataShow = ", dataShow )
        //setDataShow( dataShow.slice( val, val + 10 ) )

        settheVal( val )

        if ( val.first === 0 )
        {
            
            var localArray = []

            for( var i = 0 ; i < ((dataShow.length >= theVal.len) ? theVal.len : dataShow.length ) ; i++ )
            {
                localArray.push( dataShow[i] )
            }


            setData( localArray )

            return ; 
        }

        console.log( "count = " + count )

        console.log( "count = " , val.first + (((val.first + val.len) - count )) )

        var arr = []                                                                                      /* Hay que revisar este calculo */
        // for(  i = val.first ; i < ( ( val.first + val.length >=  count ) ? ( val.first + val.length ) : val.first +( (val.first + val.len) - count  ) ); i++ )
        for(  i = val.first ; i < (val.first + val.len) ; i++ )
        {
            if ( i >= ( dataShow.length -1 ) )
            {
                break ;
            }

            arr.push( dataShow[i] )

        }

        setData( arr )

   }


    const toggleOrder = () => {
        setOrder(prev => (prev === "Asc" ? "Desc" : "Asc"))
    }


    useEffect(() => {
        // aqui llamamos al backend ( los dejamos en data) countbygrpup

        setShowUpload( true )

        ApiCallGet( `countbygroup?order=${order}` )
        .then( (response) => {
            console.log( "response = " , response )

            var array = buildDataShow( response )

            setDataShow( array )

            setCount( array.length ) // Ponemos el maximo de registros


            var localArray = []

            for( var i = 0 ; i < ((array.length >= theVal.len) ? theVal.len : array.length ) ; i++ )
            {
                localArray.push( array[i] )
            }


            setData( localArray )
            setShowUpload( false )
        })
        .catch( (error) => {
            console.log( error )
            setShowUpload( false )
        })


    }, [order]);

    function buildDataShow( response ) {
        

        var array = []

        for (let i = 0; i < response.length; i++) {
            array.push( {
                id : i , // Ests indice nos sirve para la paginacion
                c: response[i].c,
                nombrebaseactual: response[i].nombrebaseactual
            })
        }
        return array
    }

  return (
    <div>
        <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '0.5rem' }}>
            <button
                onClick={toggleOrder}
                style={{
                    backgroundColor: '#cce4ff',
                    border: '1px solid #99c2ff',
                    borderRadius: '4px',
                    padding: '0.25rem 0.75rem',
                    cursor: 'pointer',
                    marginLeft: '1rem'
                }}
            >
                {order}
            </button>
        </div>
        <DataTable stripedRows value={data} tableStyle={{ minWidth: '50rem'  }}>
            <Column field="c" header="Contador"></Column>
            {/* <Column field="nombre" header="Nombre"></Column> */}
            <Column field="nombrebaseactual" header="NombreBaseTelcel"></Column>
            
        </DataTable>

        <MoveScroller count={count} setNewPos={(val) => onNewPos( val)}/>

        {/* <MoveScroller count={count} setNewPos={(val) => onNewPos( val)}/> */}
                {
                    showUpload && (
                        <>
                            
                            <UploadDataSpinner/>
        
                        </>
                    )
                }
    </div>
    
  )
}

export default Grouped